import { axios, API } from './config';

export const emailAPI = {
  sendContract: async (emailData) => {
    const response = await axios.post(`${API}/email/send-contract`, emailData);
    return response.data;
  },
  
  testConfig: async () => {
    const response = await axios.get(`${API}/email/test-email-config`);
    return response.data;
  },

  sendClientAccess: async (data) => {
    const response = await axios.post(`${API}/email/send-client-access`, data);
    return response.data;
  },

  // New notification endpoints
  notifyContractSigned: async (data) => {
    const response = await axios.post(`${API}/email/notify-contract-signed`, data);
    return response.data;
  },

  notifyContractReady: async (data) => {
    const response = await axios.post(`${API}/email/notify-contract-ready`, data);
    return response.data;
  },

  sendEventReminder: async (contractId, daysBefore = 7) => {
    const response = await axios.post(`${API}/email/send-event-reminder`, {
      contract_id: contractId,
      days_before: daysBefore
    });
    return response.data;
  },

  getEmailLogs: async (limit = 50, contractId = null) => {
    const params = { limit };
    if (contractId) params.contract_id = contractId;
    const response = await axios.get(`${API}/email/logs`, { params });
    return response.data;
  }
};
